//
//
//
//
//

export default {
    props: {
        slug: {
            type: String,
            default: '',
        },
    },
    computed: {
        status() {
            let result = {
                name: this.slug,
                class: 'bg-gray-100 text-gray-800',
            };
            switch (this.slug) {
                case 'pending':
                    result = {
                        name: 'Čeká na potvrzení',
                        class: 'bg-yellow-100 text-yellow-800',
                    };
                    break;

                case 'on-hold':
                    result = {
                        name: 'Čeká na úhradu',
                        class: 'bg-purple-100 text-purple-800',
                    };
                    break;

                case 'processing':
                    result = {
                        name: 'Uhrazená',
                        class: 'bg-blue-100 text-blue-800',
                    };
                    break;

                case 'completed':
                    result = {
                        name: 'Odeslaná',
                        class: 'bg-green-100 text-green-800',
                    };
                    break;

                case 'cancelled':
                    result = {
                        name: 'Zrušená',
                        class: 'bg-red-100 text-red-800',
                    };
                    break;
            }
            return result;
        },
    },
}



// WEBPACK FOOTER //
// ./scripts/vue/auth/partials/OrderStatus.vue